import { useDispatch } from "react-redux"
import useValidate from "../../store/hooks/useValidator"
import { closeModal } from "../../store/actions/modalAction"
import { memo, useCallback, useEffect, useMemo, useState } from "react"
import { callApiAction } from "../../store/actions/commonAction"
import { callSnackBar } from "../../store/actions/snackbarAction"
import { SNACK_BAR_VARIETNS } from "../../utils/constants"
import CreateProductUi from "./CreateProductUi"
import { CreateProductApi, ProductFindByIdApi, UpdateProductApi } from "../../apis/product.api"
import { Category } from "@mui/icons-material"

const CreateProductController = ({ callBack = () => { }, id, isModal, handleClick = () => { } }) => {
    const validate = useValidate()
    const dispatch = useDispatch()
    const title = "Product"

    const [loading, setLoading] = useState(false)


    const [fields, setFields] = useState({
        err: '',
        id,
        name: '',
        is_3yr_warranty: null,
        product_accessories: [{
            name: "",
        }],
        problems: [{
            name: "",
            warrenty: 0
        }],
        item: [{
            name: "",
            solution: "",
            price: 0,
        }],
        categories: "",
    })
    const [originalDocument, setOriginalDocument] = useState({})


    const validationSchemaForCreate = useMemo(() => ([

        {
            required: true,
            value: fields.name,
            field: 'Product Name'
        },
        {
            required: true,
            value: fields.is_3yr_warranty,
            field: 'Is 3 Year Warranty'
        },
        {
            required: true,
            value: fields.problems.every((item) => item.name !== ""),
            field: 'Problems Name',
        },
        {
            // required: true,
            value: fields.problems.every((item) => item.warrenty !== 0),
            field: 'Problem Warrenty Valid Years',
        },
        {
            required: true,
            value: fields.item.every((item) => item.name !== ""),
            field: 'item Name',
        },
        {
            required: true,
            value: fields.item.every((item) => item.price !== 0),
            field: 'Item Price',
        },
        {
            required: true,
            value: fields.product_accessories.every((item) => item.name !== ""),
            field: 'Product Accessories Name',
        },
    ]), [fields])

    const validationSchemaForUpdate = useMemo(() => ([

        {
            required: true,
            value: fields.name,
            field: 'Product Name'
        },
        {
            required: true,
            value: fields.is_3yr_warranty,
            field: 'Is 3 Year Warranty'
        },
        {
            required: true,
            value: fields.product_accessories.every((item) => item.name !== ""),
            field: 'Product Accessories Name',
        },
        {
            required: true,
            value: fields.problems.every((item) => item.name !== ""),
            field: 'Problems Name',
        },
        {
            // required: true,
            value: fields.problems.every((item) => item.warrenty !== 0),
            field: 'Problem Warrenty Valid Years',
        },
        {
            required: true,
            value: fields.item.every((item) => item.name !== ""),
            field: 'item Name',
        },
        {
            // required: true,
            value: fields.item.every((item) => item.price !== 0),
            field: 'Item Price',
        }
    ]), [fields])


    const createFunction = async () => {
        const validationResponse = validate(validationSchemaForCreate)

        if (validationResponse === true) {


            setLoading(true)
            dispatch(
                callApiAction(
                    async () => await CreateProductApi(fields),
                    async (response) => {

                        setLoading(false)
                        callBack()
                        dispatch(callSnackBar("Product Created Successfully", SNACK_BAR_VARIETNS.suceess))
                        dispatch(closeModal("Product"))
                        handleClick();
                    },
                    (err) => {
                        setLoading(false)
                        setFields({ ...fields, err })

                        dispatch(callSnackBar(err, SNACK_BAR_VARIETNS.error))
                    }
                )
            )
        } else {
            setFields({ ...fields, 'err': validationResponse })
        }
    }

    const updateFunction = async () => {
        const validationResponse = validate(validationSchemaForUpdate)
        const updatedData = ({ id })
        for (let field in originalDocument) {
            if (originalDocument[field] && fields[field] && fields[field] != originalDocument[field]) {
                updatedData[field] = fields[field]
            }
        }

        if (validationResponse === true) {
            setLoading(true)
            dispatch(
                callApiAction(
                    async () => await UpdateProductApi(fields),
                    async (response) => {
                        setLoading(false)
                        callBack()
                        dispatch(callSnackBar("Product Updated Successfully", SNACK_BAR_VARIETNS.suceess))
                        dispatch(closeModal("update"))
                    },
                    (err) => {
                        setLoading(false)
                        setFields({ ...fields, err })
                    }
                )
            )
        } else {
            setFields({ ...fields, 'err': validationResponse })
        }
    }



    const onSubmit = async (e) => {
        e.preventDefault()
        if (id)
            updateFunction()
        else
            createFunction()
    }



    const fetchById = useCallback((id) => {
        setLoading(true)
        dispatch(
            callApiAction(
                async () => await ProductFindByIdApi({ id }),
                async (response) => {
                    setFields(prev => ({ ...prev, ...response }));
                    setOriginalDocument(response)
                    setLoading(false)
                },
                (err) => {
                    setFields(prev => ({ ...prev, err }));
                    setLoading(false)
                }
            )
        )
    }, [dispatch])

    useEffect(() => {
        if (id) {
            fetchById(id)
        }
    }, [id, fetchById])


    return <CreateProductUi
        title={title}
        isUpdate={id}
        loading={loading}
        fields={fields}
        onSubmit={onSubmit}
        setFields={setFields}
        isModal={isModal}

    />
}
export default memo(CreateProductController)